<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Extrato de Transações" sub="Lista de movimentações das Transações" />
        <div class="row">
            <div class="col-md-3 divisoria divisoria-borda">
                Saldo Total: <br><money class="no-border" disabled v-model="saldoTotal" v-bind="money"></money>
            </div>
            <div class="col-md-3 divisoria divisoria-borda">
                Saldo Liberado para Saque: <br><money class="no-border" disabled v-model="saldoLiberado" v-bind="money"></money>
            </div>
            <div class="col-md-3 divisoria divisoria-borda">
            </div>
            <div class="col-md-3 divisoria">
                Realizar Saque: <br>
                <b-input-group id="saque">
                    <money 
                        v-model="sacar.valor" 
                        v-bind="money" 
                        class="form-control">
                    </money>
                    <b-input-group-append>
                        <b-button variant="success" @click="setSaque">Sacar</b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
        </div>
        
        <!-- SAQUE -->
        <b-modal id="modal-saque" hide-footer>
            <template v-slot:modal-title>
                Saque de valores:
            </template>
            <div class="d-block text-center">
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Valor: </b></p>
                    </div>
                    <div class="col-md-6">
                        <money 
                            v-model="sacar.valor" 
                            v-bind="money" 
                            disabled
                            class="no-border">
                        </money>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <p><b>Dados Bancários</b></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Banco: </b></p>
                    </div>
                    <div class="col-md-6">
                        <input type="text" disabled class="no-border" v-model="colaborador.banco"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Agência: </b></p>
                    </div>
                    <div class="col-md-6">
                        <input type="text" disabled class="no-border" v-model="agencia"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Conta: </b></p>
                    </div>
                    <div class="col-md-6">
                        <input type="text" disabled class="no-border" v-model="conta"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Tipo: </b></p>
                    </div>
                    <div class="col-md-6">
                        <input type="text" disabled class="no-border" v-model="tipo_conta"/>
                    </div>
                </div>
                <hr>
                <p><b>Observação: </b>Caso os dados bancários estejam errados, acesse seus dados e altere os mesmos antes de realizar o saque.</p>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Senha: </b></p>
                    </div>
                    <div class="col-md-6">
                        <b-form-input type="password" id="senha" v-model="sacar.senha"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-button variant="success" class="mt-3" block @click="realizaSaque">Sacar</b-button>
                </div>
                <div class="col-md-6">
                    <b-button variant="danger" class="mt-3" block @click="cancelaSaque">Cancelar</b-button>
                </div>
            </div>
        </b-modal>

        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table hover small striped class="text-center align-middle table" :items="extratos" :fields="fields">
                <template v-slot:cell(template_credito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-success text-strike-success"><b>{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-success">{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
                <template v-slot:cell(template_debito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-danger text-strike-danger"><b>{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-danger">{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
            </b-table>
        </div>
        <div v-else>
            <b-table hover small striped class="text-center align-middle table" :items="extratos" :fields="fields">
                <template v-slot:cell(template_credito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-success text-strike-success"><b>{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-success">{{ data.item.tipo==='credito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
                <template v-slot:cell(template_debito)="data">
                    <span v-if="data.item.liberado!=='sim'" class="text-danger text-strike-danger"><b>{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</b></span>
                    <span v-else class="text-danger">{{ data.item.tipo==='debito' ? formatMoney(data.item.valor) : '' }}</span>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'
import { VMoney } from 'v-money'

export default {
    name: 'extrato',
    components: { PageTitle },
    directives: { money: VMoney },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            extrato: {},
            extratos: [],
            valor: {},
            valores: [],
            colaborador: {},
            sacar: {},
            transacao1: {},
            transacao2: {},
            quemRecebeu: '',
            saldoTotal: '',
            saldoLiberado: '',
            agencia: '',
            conta: '',
            tipo_conta: '',
            fields: [
                { key: 'data_atualizacao', label: 'Data', formatter: 'formatData' },
                { key: 'status', label: 'Status' },
                { key: 'id_job_numero', label: 'Processo' },
                { key: 'template_credito', label: 'Crédito' },
                { key: 'template_debito', label: 'Débito' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },
    methods: {
        realizaSaque() {
            if(this.password !== '') {
                this.sacar.colaborador = this.quemRecebeu
                axios['post'](`${baseApiUrl}/backend/GENERAL/sacaValores.php`, this.sacar)
                .then(() => {
                    this.transacao1.id_colaborador = this.quemRecebeu
                    this.transacao1.id_job = '999999999'
                    this.transacao1.id_servico = '999999999'
                    this.transacao1.status = 'SAQUE_VALOR_' + this.sacar.valor
                    this.transacao1.tipo = 'debito'
                    this.transacao1.valor = this.sacar.valor
                    this.transacao1.liberado = 'sim'
                    axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao1)
                    .then(() => {
                        })
                    .catch((e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    })

                    this.transacao2.id_colaborador = this.quemRecebeu
                    this.transacao2.id_job = '999999999'
                    this.transacao2.id_servico = '999999999'
                    this.transacao2.status = 'TARIFA_SAQUE_' + this.sacar.valor
                    this.transacao2.tipo = 'debito'
                    this.transacao2.valor = '3.67'
                    this.transacao2.liberado = 'sim'
                    axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao2)
                    .then(() => {
                        })
                    .catch((e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    })

                    this.$toasted.global.defaultSuccess({ message: 'Saque realizado com sucesso!' })
                    })
                .catch((e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })
            }
        },
        cancelaSaque() {
            this.$bvModal.hide('modal-saque')
            this.sacar = {}
            this.sacar.valor = 0
        },
        setSaque() {
            alert(this.sacar.valor)
            if(this.sacar.valor <= (this.saldoLiberado - 3.67)) {
                this.$bvModal.show('modal-saque')
            } else {
                this.sacar.valor = this.saldoLiberado
                this.$bvModal.show('modal-saque')
            }
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        formatMoney(value) {
            if(value.indexOf('.') > -1) {
                const arr = value.split('.')
                const r = arr[0]
                const c = arr[1]
                if(c.length < 2) {
                    return `R$${r},${c}0`
                } else {
                    const c1 = arr[1].charAt(0)
                    const c2 = arr[1].charAt(1)
                    return `R$${r},${c1}${c2}`
                }
            } else {
                return `R$${value},00`
            }
        },
        loadExtratos() {
            const url = `${baseApiUrl}/backend/SELECT/extrato.php?colaborador=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.extratos = res.data
            })
        },
        loadValores() {
            const url = `${baseApiUrl}/backend/GENERAL/valores.php?colaborador=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.valores = res.data                    
                this.saldoTotal = 
                    ((parseFloat(this.valores[0].creditoLiberado) > 0 ? parseFloat(this.valores[0].creditoLiberado) : 0)
                    + 
                    (parseFloat(this.valores[0].creditoBloqueado) > 0 ? parseFloat(this.valores[0].creditoBloqueado) : 0))
                    - 
                    (parseFloat(this.valores[2].debito) > 0 ? parseFloat(this.valores[2].debito) : 0)
                this.saldoLiberado = 
                    (parseFloat(this.valores[0].creditoLiberado) > 0 ? parseFloat(this.valores[0].creditoLiberado) : 0)
                    - 
                    (parseFloat(this.valores[2].debito) > 0 ? parseFloat(this.valores[2].debito) : 0)
            })
        },
        loadColaborador() {
            const url = `${baseApiUrl}/backend/SELECT/colaboradores.php?id=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.colaborador = res.data[0]    
                this.agencia = this.colaborador.agencia + '-' + this.colaborador.ag_dv             
                this.conta = this.colaborador.conta + '-' + this.colaborador.conta_dv
                this.tipo_conta = this.colaborador.tipo_conta==='conta_corrente' ? 'Conta Corrente' : 'Conta Poupança'
            })
        },
        loadExtrato(extrato) {
            this.extrato = { ...extrato }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        this.loadExtratos()
        this.loadValores()
        this.loadColaborador()
        this.larguraTela = screen.width - (screen.width * 0.08)

    }
}
</script>

<style>

.table {
    font-size: 0.9rem;
}

.text-strike-success {
    text-decoration: rgb(31, 129, 54) line-through;
}

.text-strike-danger {
    text-decoration: rgb(170, 42, 54) line-through;
}

.divisoria {
    line-height:30px;
    text-align: center;
    font-style: italic;
}
.divisoria-borda {
    border-right: 1px solid rgb(199, 199, 199);
}

.no-border {
    border: 0;
    text-align: center;
    font-style: italic;
    background-color: transparent;
}

#saque, #senha {
    /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.btn-custom {
    border-radius: 10px;
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}
</style>